import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import AcryProRegistMailAddress from '../views/AcryProRegistMailAddress.vue'
import AcryProForgotPassword from '../views/AcryProForgotPassword.vue'
import AcryProContract from '../views/AcryProContract.vue'
import AcryProForm from '../views/AcryProForm.vue'
import AcryApp from '../views/AcryApp.vue'
import AcryAppForm from '../views/AcryAppForm.vue'
import ContactForm from '../views/ContactForm.vue'
import ContactFormComplete from '../views/ContactFormComplete.vue'
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import { Analytics } from "@/js/Analytics.js";
import { Device } from "@/js/utils/Device.js";
import { User } from "@/js/User.js";

Vue.use(VueRouter)

var routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: { title: 'ACRY PRO' }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { title: 'ホーム | ACRY PRO' }
  },
  {
    path: '/registmail',
    name: 'AcryProRegistMailAddress',
    component: AcryProRegistMailAddress,
    meta: { title: '新規登録 | ACRY PRO' }
  },
  {
    path: '/forgotpassword',
    name: 'AcryProForgotPassword',
    component: AcryProForgotPassword,
    meta: { title: 'パスワード再設定 | ACRY PRO' }
  },
  {
    path: '/acryproform',
    name: 'AcryProForm',
    component: AcryProForm,
    meta: { title: 'お客様情報登録 | ACRY PRO' }
  },
  {
    path: '/contract',
    name: 'AcryProContract',
    component: AcryProContract,
    meta: { title: '契約書送信 | ACRY PRO' }
  },
  {
    path: '/acryapp',
    name: 'AcryApp',
    component: AcryApp,
    meta: { title: 'ACRY PRO' }
  },
  {
    path: '/acryappform',
    name: 'AcryAppForm',
    component: AcryAppForm,
    meta: { title: 'アカウント設定 | ACRY PRO' }
  },
  {
    path: '/contact',
    name: 'ContactForm',
    component: ContactForm,
    meta: { title: 'お問い合わせ | ACRY PRO' }
  },
  {
    path: '/contactcomplete',
    name: 'ContactFormComplete',
    component: ContactFormComplete,
    meta: { title: 'お問い合わせ送信完了 | ACRY PRO' }
  },

  { path: '*', name: 'NotFound' }, // キャッチオール
]

import 'bootstrap/dist/css/bootstrap.css' // added
import 'bootstrap-vue/dist/bootstrap-vue.css' // added

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// モバイル非対応の画面 (HOME / PC専用フォーム)
const mobileBlockedPaths = ['/home', '/acryproform', '/contract'];

// 初回認証情報の取得が完了するのを待つPromise
const authReady = new Promise((resolve) => {
  const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
    unsubscribe();
    resolve(user);
  });
});

router.beforeResolve(async (to, from, next) => {
  // モバイル端末からはHOMEなどのPC専用画面へアクセスさせない
  if (mobileBlockedPaths.indexOf(to.path) !== -1 && Device.isMobile()) {
    const user = firebase.auth().currentUser || await authReady;
    if (!user) {
      next({ path: '/' });
      return;
    }
    // 未登録ならスマホ用フォームへ、登録済(契約送信済)はログイン画面へ
    const data = await User.getFBAcryProUserData().catch(() => null);
    if (data && data.isSendRequest) {
      await firebase.auth().signOut().catch(() => {});
      next({ path: '/' });
    } else {
      next({ path: '/acryappform' });
    }
    return;
  }

  if (to.path == '/' || to.path == '/registmail' || to.path == '/forgotpassword' || to.path == '/contact' || to.path == '/contactcomplete' || to.path == '/acryapp') {
    next()
  } else {
    const user = firebase.auth().currentUser || await authReady;
    if (user) {
      next()
    } else {
      next({ path: '/' })
    }
  }
})

const DEFAULT_TITLE = 'ACRY PRO'
function resolveTitle(to) {
  // ネストされた子ルートほど後ろになるので、最後に meta.title を持っているものを採用
  const lastWithTitle = [...to.matched].reverse().find(r => r.meta && r.meta.title)
  return (lastWithTitle && lastWithTitle.meta.title) || DEFAULT_TITLE
}

router.beforeEach(async (to, from, next) => {
  // 存在しないページの場合
  if (to.name == "NotFound") {
    const user = firebase.auth().currentUser || await authReady;
    if (user) {
      next({ path: Device.isMobile() ? '/acryappform' : '/home' })
    } else {
      next({ path: '/' })
    }
    return;
  }
  next();
});

router.afterEach((to) => {
  Analytics.pageView(to.fullPath);
  Vue.nextTick(() => { document.title = resolveTitle(to) })
});

export default router
